import { Loader } from '@ui-kit/components/loader';
import { useScrollToElem } from '@utils/hooks';
import React, { FC } from 'react';
import { Message } from '../../message';

type PropsType = {
  messages: Message[];
};

export const PrivateChatMessages: FC<PropsType> = ({ messages }: PropsType) => {
  function renderPrivateMessages(messages: Message[]) {
    return messages.map((elem, index) => {
      const authorJSX = elem.senderName ? (
        <div className="messages__author">{elem.senderName}:</div>
      ) : (
        ''
      );

      return (
        <div className="messages-list" key={`${elem.text}_${index}`}>
          {authorJSX}
          <div className="messages__text">{`${elem.text}`}</div>
        </div>
      );
    });
  }

  const endElem = useScrollToElem();

  return (
    <main className="lobby-chat__messages">
      {renderPrivateMessages(messages)}
      <div ref={endElem} />
    </main>
  );
};
